import * as React from 'react';
import styled from "styled-components";
import ParagraphSup from "../../atom/text/paragraph_sup";
import {ConstBreakPoint, ConstColor} from "../../../../config/styles_const/styles_const";
import {Link} from "react-router-dom";
import {TBreadcrumbItem} from "../../../type/common";

interface IProps {
    breadcrumbItems?: TBreadcrumbItem[];
}

const Breadcrumbs: React.FC<IProps> = (props) => {

    const { breadcrumbItems } = props;

    return (
        <Wrapper>
            <ol className="breadcrumb" itemScope={true} itemType="https://schema.org/BreadcrumbList">

                {
                    breadcrumbItems && breadcrumbItems.map((breadcrumbItem, index) => {
                        return (
                            <li key={breadcrumbItem.text} itemProp="itemListElement" itemScope={true}
                                itemType="https://schema.org/ListItem">
                                {
                                    breadcrumbItem.to ? (
                                        <Link itemProp="item" to={breadcrumbItem.to}>
                                            <ParagraphSup icon={breadcrumbItem.isHome ? '"\f015"' : undefined} itemProp="name">{breadcrumbItem.text}</ParagraphSup>
                                        </Link>
                                    ) : (
                                        <ParagraphSup bold={true} itemProp="name">{breadcrumbItem.text}</ParagraphSup>
                                    )
                                }
                                <meta itemProp="position" content={String(index + 2)}/>
                            </li>

                        )
                    })
                }
            </ol>
        </Wrapper>


    )

};

export default Breadcrumbs;

const Wrapper = styled.div`
    margin-bottom: 20px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 20px;
    };
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        margin-bottom: 40px;
    };
    .breadcrumb {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    
    .breadcrumb p {
        display: inline;/*横に並ぶように*/
    }
    
    .breadcrumb li:first-child p:before {
        color: ${ConstColor.Corporate};
        margin-right: 0;
    }
    
    .breadcrumb li {
        display: inline;/*横に並ぶように*/
        list-style: none;
        font-weight: bold;/*太字*/
    }
    
    .breadcrumb li:after {
    /* >を表示*/
    font-family: "Font Awesome 5 Free";
    content: "\f531";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 18px;
    color: ${ConstColor.PlaceholderAndBorder};
    
    flex: none;
    order: 1;
    align-self: center;
    margin: 10px 10px 0 10px;
    }
    
    .breadcrumb li:last-child:after {
        content: '';
    }
    
    .breadcrumb li a {
        text-decoration: none;
        color: gray;
    }
`




// WEBPACK FOOTER //
// ./src/presentation/common/molecular/breadcrumbs/breadcrumbs.tsx